import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip, Typography } from 'antd'
import { ColumnsType } from 'antd/es/table'
import classNames from 'classnames'
import noProductImage from 'assets/images/no-image-product.png'
import { IOrderItem } from 'models/orders'
import { EUnit } from 'models/product'
import { IMAGES_URL } from 'shared/constants/urls'
import { getNormalizedPrice } from 'shared/utils/getNormalizedPrice'
import { getWeightByUnit } from 'shared/utils/getWeightByUnit'
import { getItemCharacteristics } from './getItemCharacteristics'
import styles from './OrderItemsColumns.module.scss'

// Колонки позиций заказа, общие для карточки продавца и суперадмина
export const getOrderItemsColumns = (): ColumnsType<IOrderItem> => [
  {
    title: (
      <span className={styles.titleWithHelp}>
        Артикул
        <Tooltip title='Сверху — артикул продавца, снизу — артикул площадки'>
          <QuestionCircleOutlined className={styles.help} />
        </Tooltip>
      </span>
    ),
    dataIndex: 'vendor_code',
    width: 130,
    render: (_, { product_id }) =>
      product_id ? (
        <div className={styles.codes}>
          <Typography.Text>{product_id.vendor_code || '—'}</Typography.Text>
          <Typography.Text type='secondary'>{product_id.article || '—'}</Typography.Text>
        </div>
      ) : (
        <Typography.Text type='secondary'>Удален</Typography.Text>
      )
  },
  {
    title: 'Фото',
    dataIndex: 'photo',
    width: 110,
    onCell: () => ({ className: styles.photoCell }),
    render: (_, { product_id }) => {
      const photo = product_id?.photo?.[0]
      return (
        <img
          src={photo ? `${IMAGES_URL}${photo}` : noProductImage}
          alt='Изображение товара'
          className={classNames(styles.photo, { [styles.photoEmpty]: !photo })}
        />
      )
    }
  },
  {
    title: 'Наименование товара',
    dataIndex: 'name',
    width: 200,
    render: (_, { product_id }) => (
      <Typography.Text style={{ opacity: product_id?.name ? 1 : 0.5 }}>
        {product_id?.name ?? 'Удаленный товар'}
      </Typography.Text>
    )
  },
  {
    title: 'Кол-во',
    dataIndex: 'count',
    width: 90,
    render: (_, { count }) => <Typography.Text>{count} шт.</Typography.Text>
  },
  {
    title: 'Цена',
    dataIndex: 'price',
    width: 100,
    render: (_, { price }) => <Typography.Text>{getNormalizedPrice(price)}</Typography.Text>
  },
  {
    title: 'Вес (кг)',
    dataIndex: 'weight',
    width: 80,
    render: (_, { dimension, count }) => {
      const value = getWeightByUnit(EUnit.KG, dimension, count).value
      const toFixedValue = value.toString().split('.')?.[1]?.length ?? 0
      return <Typography.Text>{value.toFixed(toFixedValue)}</Typography.Text>
    }
  },
  {
    title: 'Характеристики',
    dataIndex: 'characteristics',
    width: 160,
    render: (_, { product_id }) => {
      const { variation, main } = getItemCharacteristics(product_id)
      if (variation) {
        return <Typography.Text className={styles.characteristic}>{variation}</Typography.Text>
      }
      if (!main.length) {
        return <Typography.Text type='secondary'>—</Typography.Text>
      }
      return (
        <div className={styles.characteristics}>
          {main.map(({ name, value }, index) => (
            <Typography.Text key={index} className={styles.characteristic}>
              <b>{name}:</b> {value}
            </Typography.Text>
          ))}
        </div>
      )
    }
  }
]
